<template>
  <div class="content">
    <h3> Redes Sociais </h3>
    <div class="line">
      <!-- {{$store.state.company}} -->
      <div v-for="(social, idx) in $store.state.company.social_networks" v-bind:key="idx">
      {{social.name}}: <br/><input  type="text" class="inputWire" v-model="social.url" />
      <br/><br/>
      </div>
      Whatsapp: <br/>
      <input  type="text" placeholder="(DDI)(DD)99999-9999" class="inputWire" v-model="$store.state.company.whatsapp" />
      <br/><br/>
      <button @click="saveKeys()">Salvar</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/utils/event-bus'
import axios from 'axios'
export default {

  computed: {
    ...mapGetters([ 'getOpaApi' ]),
  },

  created () {
    if(!this.$store.state.company.social_networks) {
      this.$store.state.company.social_networks = [
        {"icon": "facebook-f", "name": "facebook", "url": null},
        {"icon": "youtube-square", "name": "youtube", "url": null },
        {"icon": "instagram", "name": "instagram", "url": null},
        {"icon": "twitter", "name": "twitter", "url": null},
        {"icon": "pinterest", "name": "pinterest", "url": null },
        {"icon": "google-plus-g", "name": "google+", "url": null }
      ]
    }
  },

  methods: {
  
    async saveKeys () {
      try {
        EventBus.$emit('showLoading', true)
        let json = {
          social_networks: this.$store.state.company.social_networks,
          whatsapp: this.$store.state.company.whatsapp ? this.$store.state.company.whatsapp.replace(/\D/g,'') : null
        }
        let result = await axios.patch(this.getOpaApi +'/company/' + this.$store.state.company.Id, json)
        if (result.data) {
          this.$store.commit('setCompany', result.data)
        }
        EventBus.$emit('showLoading', false)
        EventBus.$emit('showAlert', 'success', 'chaves atualizadas')
      } catch(e) {
        let error = {e}
        console.log(error)
        EventBus.$emit('showAlert', 'error', 'erro ao atualizar chaves')
        EventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style>

</style>
